/**
 * "Viewing Jess Finlaw's desk": the line under the door's tab bar when an
 * admin opens the door as the quality lead's desk (proposal 12 E2E).
 * Renders nothing on one's own desk.
 */
import type { DoorDeskRead } from '../../services/qcpDesk';
import { deskViewingLine } from './deskOwnerView';
import styles from './QualityTriageShell.module.css';

export function DeskOwnerLine({ desk }: { desk: DoorDeskRead | null }) {
  const line = deskViewingLine(desk);
  if (!line) return null;
  return (
    <div className={styles.deskOwner} data-testid="desk-owner-line" role="note">
      {line}
    </div>
  );
}
